import React from "react";

const WhyChooseUs = () => {
  return (
    <div className="why-sec-2" id="why-sec">
      <div className="container">

        <div className="row justify-content-center">
          <div className="col-xxl-6 col-xl-7 col-lg-9">
            <div className="title-area text-center">
              <span className="sub-title">Why Choose Rising Cab Service</span>
              <h2 className="sec-title">Your Trusted Travel Partner</h2>
              <p>
                Rising Cab Service provides safe, affordable, and comfortable taxi
                services for local travel, airport transfers, outstation trips,
                and tour packages with customer satisfaction as our priority.
              </p>
            </div>
          </div>
        </div>

        <div className="row gy-30 align-items-center">

          {/* Card 1 */}
          <div className="col-lg-6 col-xl-3">
            <div className="why-card-2">
              <div className="box-icon">
                <img src="/img/icon/why_card_2_1.svg" alt="24/7 Service" />
              </div>
              <div className="box-content">
                <h3 className="box-title">24/7 Cab Availability</h3>
                <p className="box-text">
                  Book a cab anytime for local, airport, or outstation travel
                  with our reliable round-the-clock service.
                </p>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-lg-6 col-xl-3">
            <div className="why-card-2">
              <div className="box-icon">
                <img src="/img/icon/why_card_2_2.svg" alt="Affordable Rates" />
              </div>
              <div className="box-content">
                <h3 className="box-title">Affordable & Transparent Pricing</h3>
                <p className="box-text">
                  Enjoy competitive fares with no hidden charges for one-way,
                  round-trip, and airport taxi services.
                </p>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-lg-6 col-xl-3">
            <div className="why-card-2">
              <div className="box-icon">
                <img src="/img/icon/why_card_2_3.svg" alt="Drivers" />
              </div>
              <div className="box-content">
                <h3 className="box-title">Professional Drivers</h3>
                <p className="box-text">
                  Our experienced and verified drivers ensure a safe,
                  comfortable, and pleasant travel experience.
                </p>
              </div>
            </div>
          </div>

          {/* Card 4 */}
          <div className="col-lg-6 col-xl-3">
            <div className="why-card-2">
              <div className="box-icon">
                <img src="/img/icon/why_card_2_4.svg" alt="Fleet" />
              </div>
              <div className="box-content">
                <h3 className="box-title">Well-Maintained Fleet</h3>
                <p className="box-text">
                  Choose from hatchbacks, sedans, SUVs, Innova Crysta, Ertiga,
                  and premium vehicles for every travel need.
                </p>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default WhyChooseUs;